import { render, staticRenderFns } from "./DeptEdit.vue?vue&type=template&id=c3e1366c&scoped=true&"
import script from "./DeptEdit.vue?vue&type=script&lang=js&"
export * from "./DeptEdit.vue?vue&type=script&lang=js&"
import style0 from "./DeptEdit.vue?vue&type=style&index=0&id=c3e1366c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3e1366c",
  null
  
)

export default component.exports